import ApiService from '../../../../../services/ApiService'

export default {
  name: 'SubDepartment',

  data: () => ({
    apiService: new ApiService(),
    institutionId: null,

    loading: false,
    saveLoading: false,
    deleteLoading: false,

    showFilters: false,
    addDialog: false,
    deleteDialog: false,
    isEditing: false,

    subDepartments: [],
    departments: [],
    unidades: [],
    formDepartments: [],

    filterDepartmentId: null,
    filterUnidadeId: null,

    form: {
      id: null,
      name: '',
      departmentId: null,
      unidadeId: null,
    },

    selectedItem: null,

    page: 1,
    pageSize: 10,
    sizes: [10, 30, 90, 180],
    totalPages: 1,
    totalItems: 0,
  }),

  computed: {
    displayedSubDepartments() {
      return [...this.subDepartments]
    },
    filteredDepartmentsForFilter() {
      if (!this.filterUnidadeId) return this.departments
      return this.departments.filter((d) => d.unidadeId === this.filterUnidadeId)
    },
  },

  async created() {
    const institution = JSON.parse(localStorage.getItem('institution'))
    this.institutionId = institution.id
    await this.loadUnidades()
    await this.loadDepartments()
    await this.search()
  },

  methods: {
    async search() {
      this.loading = true

      const payload = {
        institutionId: this.institutionId,
        departmentId: this.filterDepartmentId ?? 0,
        unidadeId: this.filterUnidadeId ?? 0,
        page: this.page,
        pageSize: this.pageSize,
      }

      await this.apiService
        .post(`department/listFilteredSubdepartment`, payload)
        .then((response) => {
          const data = response.content.data ?? response.content

          this.subDepartments = data.map((x) => ({
            ...x,
            departmentName: x.department?.name ?? '',
            unidadeName: x.department?.unidade?.name ?? '',
            departmentId: x.departmentId ?? x.department?.id,
          }))

          this.totalPages = response.content.pager?.totalPages ?? 1
          this.totalItems = response.content.pager?.totalItems ?? data.length
        })
        .catch(() => {
          this.$toast.error(this.$t('Erro ao carregar sub-setores'))
        })
        .finally(() => {
          this.loading = false
        })
    },

    async loadUnidades() {
      await this.apiService
        .get(`unidade/list/${this.institutionId}`)
        .then((response) => {
          this.unidades = (response.content ?? []).map((x) => ({
            id: x.id,
            name: x.name,
          }))
        })
        .catch(() => {})
    },

    async loadDepartmentsByUnidade(unidadeId) {
      this.formDepartments = []
      if (!unidadeId) return
      await this.apiService
        .get(`department/list/unidade/${unidadeId}`)
        .then((response) => {
          this.formDepartments = (response.content ?? []).map((x) => ({
            id: x.id,
            name: x.name,
          }))
        })
        .catch(() => {})
    },

    async loadDepartments() {
      await this.apiService
        .post(`department/listFilteredSubdepartment`, {
          institutionId: this.institutionId,
          departmentId: 0,
          page: 1,
          pageSize: 999,
        })
        .then((response) => {
          const data = response.content.data ?? response.content
          const seen = new Set()
          this.departments = data
            .filter(
              (x) =>
                x.department &&
                !seen.has(x.department.id) &&
                seen.add(x.department.id)
            )
            .map((x) => ({
              id: x.department.id,
              name: x.department.name,
              unidadeId: x.department.unidade?.id ?? null,
              label: x.department.unidade?.name
                ? `${x.department.name} / ${x.department.unidade.name}`
                : x.department.name,
            }))
        })
        .catch(() => {
          this.$toast.error(this.$t('Erro ao carregar setores'))
        })
    },

    applyFilter() {
      this.page = 1
      this.search()
    },

    openAddDialog() {
      this.isEditing = false
      this.form = { id: null, name: '', departmentId: null, unidadeId: null }
      this.formDepartments = []
      this.addDialog = true
      this.$nextTick(() => {
        if (this.$refs.addForm) this.$refs.addForm.resetValidation()
      })
    },

    openEditDialog(item) {
      this.isEditing = true
      this.form = {
        id: item.id,
        name: item.name,
        departmentId: item.departmentId,
      }
      this.addDialog = true
      this.$nextTick(() => {
        if (this.$refs.addForm) this.$refs.addForm.resetValidation()
      })
    },

    async save() {
      if (!this.$refs.addForm.validate()) return
      this.saveLoading = true

      const endpoint = this.isEditing
        ? 'department/subdepartment/edit'
        : 'department/subdepartment/add'

      const payload = this.isEditing
        ? this.form
        : { name: this.form.name, departmentId: this.form.departmentId }

      await this.apiService
        .post(endpoint, payload)
        .then(() => {
          this.$toast.success(
            this.isEditing
              ? this.$t('Sub-setor atualizado com sucesso')
              : this.$t('Sub-setor adicionado! 👍')
          )
          this.addDialog = false
          this.search()
        })
        .catch(() => {
          this.$toast.error(
            this.isEditing
              ? this.$t('Erro ao atualizar sub-setor')
              : this.$t('Erro ao adicionar sub-setor')
          )
        })
        .finally(() => {
          this.saveLoading = false
        })
    },

    openDeleteDialog(item) {
      this.selectedItem = item
      this.deleteDialog = true
    },

    async remove() {
      this.deleteLoading = true
      await this.apiService
        .delete(`department/subdepartment/delete/${this.selectedItem.id}`)
        .then(() => {
          this.$toast.success(this.$t('Sub-setor excluído com sucesso'))
          this.deleteDialog = false
          this.search()
        })
        .catch(() => {
          this.$toast.error(this.$t('Erro ao excluir sub-setor'))
        })
        .finally(() => {
          this.deleteLoading = false
        })
    },

    async activateItem(item) {
      await this.apiService
        .post('department/subdepartment/edit', { ...item, status: 0 })
        .then(() => {
          this.$toast.success(this.$t('Sub-setor ativado com sucesso'))
          this.search()
        })
        .catch(() => {
          this.$toast.error(this.$t('Erro ao ativar sub-setor'))
        })
    },

    async addSubDep(subDepartment) {
      await this.apiService
        .post('department/subdepartment/add', subDepartment)
        .then((response) => {
          this.$toast.success(this.$t('Sub-setor adicionado! 👍'))
          this.search()
          return response.content
        })
        .catch(() => {
          this.$toast.error(this.$t('Erro ao adicionar sub-setor'))
        })
    },

    async editSubDep(subDepartment) {
      await this.apiService
        .post('department/subdepartment/edit', subDepartment)
        .then(() => {
          this.$toast.success(this.$t('Sub-setor atualizado com sucesso'))
          this.search()
        })
        .catch(() => {
          this.$toast.error(this.$t('Erro ao atualizar sub-setor'))
        })
    },

    async removeSubDep(id) {
      await this.apiService
        .delete(`department/subdepartment/delete/${id}`)
        .then(() => {
          this.$toast.success(this.$t('Sub-setor removido com sucesso'))
          this.search()
        })
        .catch(() => {
          this.$toast.error(this.$t('Erro ao remover sub-setor'))
        })
    },
  },

  watch: {
    page() {
      this.search()
    },
    pageSize() {
      this.page = 1
      this.search()
    },
    filterUnidadeId() {
      this.filterDepartmentId = null
    },
    'form.unidadeId'(val) {
      this.form.departmentId = null
      this.loadDepartmentsByUnidade(val)
    },
  },
}
